export default "__VITE_ASSET__CSPlRN_V__"